export default "__VITE_ASSET__C2ieDXa3__"